import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Mobile = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M14.1598 4.66683V11.3335C14.1598 14.0002 13.4932 14.6668 10.8265 14.6668H6.8265C4.15983 14.6668 3.49316 14.0002 3.49316 11.3335V4.66683C3.49316 2.00016 4.15983 1.3335 6.8265 1.3335H10.8265C13.4932 1.3335 14.1598 2.00016 14.1598 4.66683Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1598 3.66683H7.49316"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.82606 12.7335C9.39675 12.7335 9.85939 12.2709 9.85939 11.7002C9.85939 11.1295 9.39675 10.6668 8.82606 10.6668C8.25536 10.6668 7.79272 11.1295 7.79272 11.7002C7.79272 12.2709 8.25536 12.7335 8.82606 12.7335Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Mobile.displayName = 'Mobile';
